module.exports = "/static/assets/6433bb08b9d15d5888e9492b2111024f.png";